<app-masterheader></app-masterheader>

<div class="wrapper">
    <app-sidebar></app-sidebar>
    <div id="content">
        <div class="execution-steps-wrapper">
            <header class="execution-header d-flex align-items-center justify-content-between mb-4">
                <button class="btn btn-outline-primary back-button" (click)="goBack()"
                    aria-label="Go back to previous view" title="Back" data-bs-toggle="tooltip">
                    <i class="fas fa-arrow-left"></i>
                </button>
                <h1 class="execution-title m-0">APO Execution</h1>
                <div class="spacer"></div> <!-- Spacer for alignment -->
            </header>
            <div class="execution-steps-container d-flex">
                <div class="menu-bar">
                    <div class="progress mb-3">
                        <div class="progress-bar bg-success" role="progressbar" [style.width]="getProgress() + '%'"
                            [attr.aria-valuenow]="getProgress()" aria-valuemin="0" aria-valuemax="100">
                            {{ getProgress() | number:'1.0-0' }}%
                        </div>
                    </div>
                    <ul class="nav nav-tabs flex-column" id="executionTabs" role="tablist">
                        <li class="nav-item" *ngFor="let step of steps" [ngClass]="{'completed': step.isComplete}">
                            <button class="nav-link d-flex align-items-center" [class.active]="step === selectedStep"
                                [id]="step.tabId + '-tab'" data-bs-toggle="tab" [attr.data-bs-target]="'#' + step.tabId"
                                type="button" role="tab" [attr.aria-controls]="step.tabId"
                                [attr.aria-selected]="step === selectedStep" (click)="selectStep(step)"
                                [title]="step.description" data-bs-toggle="tooltip">
                                <i class="fas me-2" [ngClass]="{
                                        'fa-map': step.tabId === 'kml',
                                        'fa-image': step.tabId === 'images',
                                        'fa-file-alt': step.tabId === 'plan',
                                        'fa-file-pdf': step.tabId === 'dpr',
                                        'fa-file-contract': step.tabId === 'tender',
                                        'fa-file-invoice': step.tabId === 'workorder',
                                        'fa-certificate': step.tabId === 'completion',
                                        'text-success': step.isComplete
                                        }"></i>
                                {{ step.name }}
                                <i *ngIf="step.isComplete" class="fas fa-check-circle ms-auto text-success"></i>
                            </button>
                        </li>
                    </ul>
                </div>
                <div class="tab-content content-area flex-grow-1 p-4">
                    <div *ngFor="let step of steps" class="tab-pane fade" [class.show]="step === selectedStep"
                        [class.active]="step === selectedStep" [id]="step.tabId" role="tabpanel"
                        [attr.aria-labelledby]="step.tabId + '-tab'">
                        <h2 class="mb-4">{{ step.name }}</h2>
                        <div *ngIf="!step.isComplete" class="step-form">
                            <div class="mb-4">
                                <label for="fileUpload-{{step.tabId}}" class="form-label">Upload Document</label>
                                <div class="input-group">
                                    <input type="file" class="form-control" [id]="step.tabId + '-file'"
                                        (change)="onFileSelected($event)" accept="image/*,.pdf,.kml" />
                                    <button class="btn btn-primary" [disabled]="!selectedFile || isUploading"
                                        (click)="uploadDocument()">
                                        <span *ngIf="isUploading" class="spinner-border spinner-border-sm me-2"></span>
                                        Upload
                                    </button>
                                </div>
                                <div *ngIf="fileError" class="text-danger mt-2">{{ fileError }}</div>
                            </div>
                            <div class="mb-4">
                                <label for="comment-{{step.tabId}}" class="form-label">Add Comment</label>
                                <textarea [(ngModel)]="commentText" class="form-control" [id]="step.tabId + '-comment'"
                                    placeholder="Enter your comment here..." rows="4"></textarea>
                                <button class="btn btn-primary mt-2"
                                    [disabled]="!commentText.trim() || isSubmittingComment" (click)="addComment()">
                                    <span *ngIf="isSubmittingComment"
                                        class="spinner-border spinner-border-sm me-2"></span>
                                    Submit Comment
                                </button>
                                <div *ngIf="commentError" class="text-danger mt-2">{{ commentError }}</div>
                            </div>
                        </div>
                        <div *ngIf="step.isComplete" class="step-details">
                            <h3 class="mb-3">Uploaded Documents</h3>
                            <div class="document-list row">
                                <div *ngIf="step.documents.length === 0" class="col-12 text-muted">
                                    No documents uploaded.
                                </div>
                                <div *ngFor="let doc of step.documents" class="col-md-6 mb-3">
                                    <div class="card document-item h-100">
                                        <div class="card-body">
                                            <h6 class="card-title">{{ doc.docType }}</h6>
                                            <p class="card-text">
                                                <a [href]="baseUrl + doc.documentPath" target="_blank" class="doc-link">
                                                    <i class="fas fa-file me-1"></i> {{ doc.documentName }}
                                                </a>
                                            </p>
                                            <div *ngIf="isImage(doc)" class="image-preview">
                                                <a [href]="baseUrl + doc.documentPath" target="_blank">
                                                    <img [src]="baseUrl + doc.documentPath" [alt]="doc.documentName"
                                                        class="img-fluid" />
                                                </a>
                                            </div>
                                            <div *ngIf="doc.latitude && doc.longitude" class="mt-2">
                                                <small><strong>Coordinates:</strong> Lat: {{ doc.latitude }}, Lon: {{
                                                    doc.longitude }}</small>
                                            </div>
                                            <div *ngIf="doc.propertyGeoJson" class="mt-2">
                                                <small><strong>Area:</strong>

                                                    sq units</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h3 class="mb-3 mt-4">Comments</h3>
                            <div class="comment-list">
                                <div *ngIf="step.comments.length === 0" class="text-muted">
                                    No comments added.
                                </div>
                                <div *ngFor="let comment of step.comments; let i = index" class="comment-item mb-3">
                                    <div class="d-flex">
                                        <div class="comment-avatar me-3">
                                            <i class="fas fa-user-circle fa-2x text-muted"></i>
                                        </div>
                                        <div class="flex-grow-1">
                                            <div class="d-flex justify-content-between">
                                                <strong>Comment {{ i + 1 }} (ID: {{ comment.id }})</strong>
                                                <small class="text-muted">{{ comment.timestamp | date:'short' }}</small>
                                            </div>
                                            <p class="mb-0">{{ comment.text }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!selectedStep" class="text-muted">
                        Please select a step from the menu.
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="footer">
        <app-masterfooter></app-masterfooter>
    </div>
</div>